import { Field, FieldProps } from 'formik';
import React, { ReactNode } from 'react';
import { FormattedMessage, InjectedIntl, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { InfoTooltip } from '../components/InfoTooltip';
import RadioButtonNormal from '../components/RadioButtonNormal';
import ValidationErrors from './validationErrors';

interface IRadioButtonNormalFieldProps {
    id: string;
    label: FormattedMessage.MessageDescriptor | string;
    intl: InjectedIntl;
    value?: boolean;
    required?: boolean;
    tooltipText?: FormattedMessage.MessageDescriptor | string;
    qaId?: string;
    disabled?: boolean;
    onCheck: () => void;
}

interface IRadioButtonNormalFieldState {
    checked: boolean;
}

const RadioButtonNormalFieldWrapper = styled.div`
    padding-right: 5px;
`;

class RadioButtonNormalField extends React.Component<
    IRadioButtonNormalFieldProps,
    IRadioButtonNormalFieldState
> {
    private readonly ID: string;

    constructor(props: IRadioButtonNormalFieldProps) {
        super(props);
        const { id, value } = this.props;

        this.state = {
            checked: Boolean(value),
        };
        this.ID = id;
        this.validate = this.validate.bind(this);
        this.renderRadioButtonField = this.renderRadioButtonField.bind(this);
    }

    public render() {
        return (
            <Field name={this.ID} validate={this.validate} render={this.renderRadioButtonField} />
        );
    }

    private validate(value: string): string {
        const { intl, required } = this.props;

        if (!value && required) {
            return ValidationErrors.fieldRequiredMessage(intl, '');
        }

        return '';
    }

    private renderRadioButtonField({
        field,
        form: { touched, errors, setFieldValue },
    }: FieldProps): ReactNode {
        const { id, label, intl, value, required, tooltipText, onCheck } = this.props;
        const checked = Boolean(value);
        const isTouched = touched && touched[this.ID];
        const errorMessage = isTouched && errors && errors[this.ID] ? errors[this.ID] : undefined;
        const labelMessage: string = typeof label === 'string' ? label : intl.formatMessage(label);

        return (
            <RadioButtonNormalFieldWrapper>
                <RadioButtonNormal id={id} label={label} onCheck={onCheck} value={value} />
                {tooltipText ? <InfoTooltip id={id} tooltipText={tooltipText} uniqueId={id} /> : ''}
            </RadioButtonNormalFieldWrapper>
        );
    }
}

export default injectIntl(RadioButtonNormalField);
